import { render } from "./ScoreDMM.vue?vue&type=template&id=3b05f75c&scoped=true"
import script from "./ScoreDMM.vue?vue&type=script&lang=js"
export * from "./ScoreDMM.vue?vue&type=script&lang=js"

import "./ScoreDMM.vue?vue&type=style&index=0&id=3b05f75c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b05f75c"]])

export default __exports__